export enum NfeStatus {
  Created = 0,
  Pending = 1,
  Authorized = 2,
  Rejected = 3,
  Denied = 4,
  Cancelled = 5,
  Closed = 6,
  Error = 7
};
